"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    MuiTooltip: {
        tooltip: {
            borderRadius: 12,
            padding: 16,
            fontSize: '1em',
            boxShadow: '0 16px 40px -12.125px rgba(0,0,0,0.3)',
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9vbHRpcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vdmVycmlkZXMvdG9vbHRpcC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGtCQUFlLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUN2QixVQUFVLEVBQUU7UUFDVixPQUFPLEVBQUU7WUFDUCxZQUFZLEVBQUUsRUFBRTtZQUNoQixPQUFPLEVBQUUsRUFBRTtZQUNYLFFBQVEsRUFBRSxLQUFLO1lBQ2YsU0FBUyxFQUFFLHVDQUF1QztTQUNuRDtLQUNGO0NBQ0YsQ0FBQyxDQUFDIn0=